// eslint-disable-next-line security/detect-unsafe-regex
const protocolAndDomainRE = /^(?:[a-zA-Z][\w+.-]*:)?\/\/([^\s/]+(?:\/[^\s]*)?)$/;
// eslint-disable-next-line security/detect-unsafe-regex
const localhostDomainRE = /^localhost(:\d+)?(\/[^\s]*)?$/;
const nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;

/**
 * Loosely validate a URL `string`.
 *
 * @param {String} string
 * @return {Boolean}
 */

const validateUrl = (string) => {
  if (typeof string !== 'string') {
    return false;
  }

  // Remove 'blob:' protocol if present
  const sanitizedString = string.replace(/^blob:/, '');

  const match = sanitizedString.match(protocolAndDomainRE);

  if (!match) {
    return false;
  }

  const everythingAfterProtocol = match[1];

  if (!everythingAfterProtocol) {
    return false;
  }

  if (string.includes('https://localhost')) {
    return false;
  }

  if (localhostDomainRE.test(everythingAfterProtocol) || nonLocalhostDomainRE.test(everythingAfterProtocol)) {
    return true;
  }

  return false;
};

export default validateUrl;
